import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'

type LayoutProps = {
  className?: string
}

export const OuterLayout = ({
  className,
  children,
}: PropsWithChildren<LayoutProps>) => {
  return (
    <div className={cn('mx-auto my-0 flex h-fit w-fit grow', className)}>
      {children}
    </div>
  )
}

export const InnerLayout = ({
  className,
  children,
}: PropsWithChildren<LayoutProps>) => {
  return (
    <div
      className={cn(
        'mx-6 my-10 w-[1080px] min-w-[1080px] shrink-0 grow',
        className,
      )}
    >
      {children}
    </div>
  )
}

export const Layout = ({
  className,
  children,
}: PropsWithChildren<LayoutProps>) => {
  return (
    <OuterLayout>
      <InnerLayout className={className}>{children}</InnerLayout>
    </OuterLayout>
  )
}
